export const WITHDRAWN_MARKER = '[[WITHDRAWN]]'
export const WITHDRAWN_LABEL = 'Withdrawn'

export function isWithdrawn(firstName: string | null | undefined): boolean {
  return firstName === WITHDRAWN_MARKER
}

// capitalize each word in a string
export function capitalize(str: string): string {
  if (!str) return "";
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}
